import { httpClient } from '@/app/libs/axios';

export async function refreshToken(token: string) {
  return httpClient.get<{ accessToken: string; refreshToken: string }>('/refreshtoken', {
    params: { refreshToken: token },
    safeErrorStatus: [401],
  });
}
